<template>
  <div class="search-result">
    <div v-if="!noHr" class='hr-line-dashed'></div>
    <div class="row">
      <div class="col-xs-8">
        <h3>
          {{ job.name }}
        </h3>
        <p class="search-type-label">
          <span v-if="processedAt">
            {{ processedAt }}
          </span>
        </p>
        <div v-html="jobStatus"></div>
      </div>
      <div class="col-xs-4">
        <div class="text-right">
          <p class="search-type-label" v-if="succeeded">
            Succeeded
          </p>
          <p class="search-type-label" v-else-if="failed">
            Failed
          </p>
          <p class="search-type-label" v-else>
            Processing
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { urlHelperMixin } from './mixins/url_helper_mix';

export default {
  name: 'merge-job-result',
  props: {
    job: {
      type: Object,
      required: true
    },
    noHr: {
      type: Boolean,
      default: false
    },
  },
  mixins: [
    urlHelperMixin
  ],
  computed: {
    processedAt() {
      if (!this.job.processed_at) {
        return '';
      }

      return moment(this.job.processed_at)
        .format('M/D/YYYY, hh:mm a');
    },
    succeeded() {
      return this.job.status === "ready";
    },
    failed() {
      return this.job.status === "failed";
    },
    jobStatus() {
      switch (this.job.status) {
        case 'requested':
        case 'processing':
        case 'queued':
          return '<p class="m-b-none"><i class=\'fa-solid fa-circle-notch\'></i></p>';
        case 'ready':
          return `<p class='text-success m-b-none'><i class='fa-regular fa-circle-check'></i> ${this.job.result}</p>`;
        case 'failed':
          return `<p class='text-danger m-b-none'><i class='fa-solid fa-circle-xmark'></i> ${this.job.result}</p>`;
        default:
          return '';
      }
    }
  }
};
</script>
